import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodFormService {

  public bearer: string|undefined;
}
